import { concat, of } from 'rxjs';
import * as Actions from './rate-browser.actions';
import * as RateViewerActions from '../rate-viewer/rate-viewer.actions';
import { RateViewerTypes } from '../../enums/rate-viewer-types';
import get from 'lodash.get';

// TODO: adjust for expected schema to support shipment-configuration-widget/weight-input, if adding metric support may need to revert for obj instead of raw weight (use newWeight instead)
const adjustWeightForRateBrowser = (model) => ({
  weight: {
    unit: get(model, 'weight.weightUnit', 'Ounces'),
    value: get(model, 'weight.weight', 0),
  },
});

export const buildBrowseRatesRequestFromConfigureRatesModel = (model) => ({
  ...model,
  ...adjustWeightForRateBrowser(model),
});

export const onBrowseRatesWithModel = (model) => {
  const request = buildBrowseRatesRequestFromConfigureRatesModel(model);
  return concat(of(Actions.updateConfigureRatesModel(model)), of(RateViewerActions.loadRates(RateViewerTypes.rateBrowser, request)));
};
